import React from "react";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <h1>
      <Link to = '/home'>Where in the world?</Link>
    </h1>
  );
};

export default Logo;
